import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const DAILY_WARMUP_CONFIG = enabledOn(
  PlatformSlug.DATBooster,
  PlatformSlug.OATBooster,
  PlatformSlug.DATCrusher,
  PlatformSlug.PATBooster,
  PlatformSlug.INBDEBooster,
  PlatformSlug.CasperBooster,
  PlatformSlug.NBDHEBooster,
  PlatformSlug.NDEBCrusher,
  PlatformSlug.GREBooster
)

export const isDailyWarmupAvailable = (slug?: PlatformSlug) => isFeatureAvailable(DAILY_WARMUP_CONFIG, slug)
